module.exports = __webpack_public_path__ + "static/DonaAlt-Bold-ea2327df69991f8d454170eeb0c3feb2.woff2";